import React from 'react';

/**
 * ClanKpis (compact)
 * Muestra una tira de KPIs resumidos:
 * - Tesoro total (Ryo)
 * - Técnicas y Firmas
 * - Legendarias (Arsenal)
 * - Stacks de materiales
 * - Territorios controlados
 * - Tu prestigio (si disponible)
 *
 * Props:
 * - treasureTotal: number|null
 * - techniquesCount: number
 * - signatureCount: number
 * - legendaryCount: number|null
 * - materialStacks: number|null
 * - territoriesControlled: number
 * - mePrestige: { points:number, rank:number } | null
 */
export default function ClanKpis({
  treasureTotal = null,
  techniquesCount = 0,
  signatureCount = 0,
  legendaryCount = null,
  materialStacks = null,
  territoriesControlled = 0,
  mePrestige = null,
}) {
  const items = [
    {
      key: 'treasure',
      icon: '💰',
      label: 'Tesoro',
      value: treasureTotal != null ? formatNumber(treasureTotal) + ' Ryo' : '—',
      hint: 'Total en tesoro',
    },
    {
      key: 'techs',
      icon: '📜',
      label: 'Técnicas',
      value: `${safeNum(techniquesCount)} · ${safeNum(signatureCount)} firmas`,
      hint: 'Técnicas / Firmas',
    },
    {
      key: 'legend',
      icon: '🗡️',
      label: 'Legendarias',
      value: legendaryCount != null ? String(legendaryCount) : '—',
      hint: 'Armas legendarias',
    },
    {
      key: 'mats',
      icon: '🔷',
      label: 'Materiales',
      value: materialStacks != null ? String(materialStacks) : '—',
      hint: 'Stacks totales',
    },
    {
      key: 'territories',
      icon: '🗺️',
      label: 'Territorios',
      value: String(safeNum(territoriesControlled)),
      hint: 'Hexes controlados',
    },
  ];

  if (mePrestige && typeof mePrestige.points === 'number' && typeof mePrestige.rank === 'number') {
    items.push({
      key: 'prestige',
      icon: '⭐',
      label: 'Tu prestigio',
      value: `${formatNumber(mePrestige.points)} pts ( #${mePrestige.rank} )`,
      hint: 'Puntos y rango actual',
    });
  }

  return (
    <div className="clan-kpis" role="group" aria-label="Resumen del clan">
      {items.map((it) => (
        <div className="kpi-card" key={it.key} title={it.hint}>
          <div className="kpi-row">
            <span className="kpi-icon" aria-hidden="true">{it.icon}</span>
            <span className="kpi-label">{it.label}</span>
          </div>
          <div className="kpi-value">{it.value}</div>
        </div>
      ))}
    </div>
  );
}

function formatNumber(n) {
  try {
    return new Intl.NumberFormat('es-ES').format(n);
  } catch {
    return String(n);
  }
}

function safeNum(n) {
  return Number.isFinite(n) ? n : 0;
}